import React from 'react';
import 'react-perfect-scrollbar/dist/css/styles.css';
import { Accordion, Card, Button } from 'react-bootstrap';
import { cloneDeep, set, map, get } from 'lodash';
import { useTranslation } from 'react-i18next';
import { useNotificationState } from './NotificationProvider';

function SettingList() {
  const { t } = useTranslation('modules/chat');
  const { notState, setNotificationState } = useNotificationState();
  const { settingModuleArray, expandedPanel, chatEmailEnabled } = notState;

  const handleChatEmailToggle = (e) => {
    setNotificationState((prev) => ({ ...prev, chatEmailEnabled: e.target.checked }));
  };

  const customSettingPath = (index, name, chIndex, chName) => {
    return {
      parentPath: `[${index}][${name}]`,
      childpath: `[${index}][${name}][${chIndex}][${chName}]`,
    };
  };

  const handleChange = (value, path, pIndex, keyName) => {
    const cloneSeeting = cloneDeep(settingModuleArray);
    if (['selectAll', 'isParentChecked'].includes(keyName) && pIndex >= 0) {
      let getChildNodes = get(cloneSeeting, customSettingPath(pIndex, 'childNodes').parentPath, []);
      if (getChildNodes?.length) {
        getChildNodes = map(getChildNodes, (obj) => {
          return { ...obj, isChecked: value };
        });
      }
      set(cloneSeeting, customSettingPath(pIndex, 'childNodes').parentPath, getChildNodes);
      if (keyName === 'isParentChecked') {
        set(cloneSeeting, `${path}`, value);
      }
    } else {
      set(cloneSeeting, `${path}`, value);
      const getUnchecked = get(cloneSeeting, `${pIndex}.childNodes`);
      const anyUnchecked = getUnchecked.some((childNode) => !childNode.isChecked && childNode.keyName !== 'selectAll');
      if (anyUnchecked) {
        set(cloneSeeting, `${pIndex}.childNodes[0].isChecked`, false);
      } else {
        set(cloneSeeting, `${pIndex}.childNodes[0].isChecked`, true);
      }
    }
    setNotificationState((prev) => ({
      ...prev,
      settingModuleArray: cloneSeeting,
    }));
  };

  const checkAccodionActiveState = (str) => expandedPanel?.includes(str);
  const handleClickToggle = (eventKey) => {
    const copyaccodionArray = expandedPanel;
    const accIndex = copyaccodionArray.indexOf(eventKey);
    if (accIndex >= 0) {
      copyaccodionArray.splice(accIndex, 1);
    } else copyaccodionArray.push(eventKey);
    setNotificationState((prev) => ({
      ...prev,
      expandedPanel: copyaccodionArray,
    }));
  };

  return (
    <>
      <Accordion>
        <Card className="rounded-0">
          <Card.Header>
            <div className="d-flex align-items-center">
              <div className="custom-control custom-switch">
                <input
                  type="checkbox"
                  className="custom-control-input"
                  id="chatEmailNotifications"
                  checked={chatEmailEnabled ?? true}
                  onChange={handleChatEmailToggle}
                />
                <label className="custom-control-label" htmlFor="chatEmailNotifications" />
              </div>
              <span>{t('CHAT.SETTINGS.CHAT_EMAIL_NOTIFICATIONS')}</span>
            </div>
          </Card.Header>
        </Card>
      </Accordion>

      {settingModuleArray?.map((pset, index) => {
        return (
          <Accordion activeKey={checkAccodionActiveState(pset?.moduleName)} key={pset?.moduleName}>
            <Card className="rounded-0">
              <Card.Header>
                <div className="d-flex">
                  <div className="custom-control custom-switch">
                    <input
                      type="checkbox"
                      className="custom-control-input"
                      id={pset?.moduleName}
                      checked={pset?.isParentChecked}
                      onChange={(e) => handleChange(e.target.checked, customSettingPath(index, 'isParentChecked').parentPath, index, 'isParentChecked')}
                    />
                    <label className="custom-control-label" htmlFor={pset?.moduleName} />
                  </div>
                  <span>{pset?.title}</span>
                  <Accordion.Toggle
                    className="btn-toggle p-0 ml-auto"
                    as={Button}
                    variant="link"
                    eventKey={checkAccodionActiveState(pset?.moduleName)}
                    onClick={() => handleClickToggle(pset?.moduleName)}
                  >
                    <i className={checkAccodionActiveState(pset?.moduleName) ? 'icon-new-down-arrow-icon f-18 inverse' : 'icon-new-down-arrow-icon f-18'} />
                  </Accordion.Toggle>
                </div>
              </Card.Header>
              <Accordion.Collapse eventKey={checkAccodionActiveState(pset?.moduleName)}>
                <Card.Body className="setting-ul-container">
                  <ul>
                    {pset?.childNodes?.map((chSet, chInd) => {
                      if (pset?.moduleName === 'sample' && chSet?.keyName === 'supplierSuggestions') {
                        return null;
                      }
                      return (
                        <li key={chSet?.keyName} className="setting-row-with-icon">
                          <div className="common-checkbox">
                            <input
                              type="checkbox"
                              id={`${chSet?.name}_${pset?.moduleName}`}
                              checked={chSet?.isChecked}
                              onChange={(e) =>
                                handleChange(e.target.checked, customSettingPath(index, 'childNodes', chInd, 'isChecked').childpath, index, chSet?.keyName)
                              }
                            />
                            <label htmlFor={`${chSet?.name}_${pset?.moduleName}`} className="chklabel">
                              <span>{chSet?.name}</span>
                            </label>
                          </div>
                        </li>
                      );
                    })}
                  </ul>
                </Card.Body>
              </Accordion.Collapse>
            </Card>
          </Accordion>
        );
      })}
    </>
  );
}

export default SettingList;
